import { GET_ORDER_PREFERENCES_API } from 'constants/AppConstants';

export default async (userId) => {
  try {
    const response = await fetch(GET_ORDER_PREFERENCES_API.replace(':userId', userId));
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
